/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { colors, gridSize } from '@atlaskit/theme';

export const Card = styled.div`
  & + & {
    margin-top: ${gridSize() * 1.5}px;
  }
`;

export const ImageContainer = styled.div`
  text-align: center;

  > img {
    width: 120px;
  }
`;

export const DividingLine = styled.hr`
  border: none;
  height: 1px;
  background-color: ${colors.N40A};
  margin: ${gridSize() * 0.5}px;
`;

export const Link = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  padding-top: ${gridSize() * 0.5}px;
  padding-bottom: ${gridSize() * 0.25}px;
`;

export const Description = styled.p`
  font-weight: normal;
  padding-left: ${gridSize() * 0.5}px;
  padding-bottom: ${gridSize() * 0.5}px;
`;
